// libs
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
// dls
import { Svg16 as ArrowRight } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronRight';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// contants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './Breadcrumbs.module.scss';
function Breadcrumbs({ crumbs }) {
    const renderCrumbs = () => {
        return crumbs.map((crumb, index) => (React.createElement("div", { key: index, className: styles.crumbWrapper },
            React.createElement(Link, { to: crumb.path, className: styles.crumb },
                React.createElement(Text, { variant: index === crumbs.length - 1
                        ? DlsFontVariants.body_B1_Bold
                        : DlsFontVariants.body_B1_Reg, color: index === crumbs.length - 1
                        ? DlsColorTokens.text_Highest_Emphasis
                        : DlsColorTokens.text_Med_Emphasis }, crumb.title)),
            index < crumbs.length - 1 && (React.createElement("span", { className: styles.separator },
                React.createElement(GenericIcon, { Icon: ArrowRight, fillColor: DlsColorTokens.text_Low_Emphasis }))))));
    };
    return (React.createElement(React.Fragment, null, crumbs.length > 0 && (React.createElement("div", { className: cx(styles.containerWrapper, {
            [styles]: crumbs.length === 0,
        }) },
        React.createElement("div", { className: styles.container }, renderCrumbs())))));
}
export default memo(Breadcrumbs);
